export default __webpack_public_path__ + "static/media/loader.7f2c58d5.gif";